











































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import {
  APP_SERVER_HOST
} from '@/constants'

@Component({
  components: {
    Icon
  }
})
export default class ElectronicRecordAgreement extends Vue {
  APP_SERVER_HOST: string = APP_SERVER_HOST;
}
